import logInspirationalListClicked from '@alltrails/amplitude/events/logInspirationalListClicked';
import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import ContentCard from '@alltrails/denali/components/ContentCard';
import type { SponsoredCollection } from '../../../../utils/types';
import styles from './styles.module.scss';

type Props = {
  collection: SponsoredCollection;
  carouselIndex: number;
  carouselLength: number;
};

const SponsoredListCard = ({ collection, carouselIndex, carouselLength }: Props) => {
  const { title, subtitle, sponsor_name, hero_image, sponsor_logo, slug, list_type } = collection;

  const handleClick = () => {
    logInspirationalListClicked({
      carousel_index: carouselIndex,
      carousel_length: carouselLength,
      description: subtitle,
      location: 'web home page sponsored list carousel',
      page_slug: slug,
      inspirational_list_type: list_type
    });
  };

  const sponsorLogoElement = (
    <div className={styles.sponsorBadge}>
      <div className={styles.sponsorLogoCircle}>
        <Image src={sponsor_logo} alt={sponsor_name} width={96} height={96} className={styles.sponsorLogo} />
      </div>
      <Typography variant="text100bold" className={styles.sponsorName}>
        {sponsor_name}
      </Typography>
    </div>
  );

  return (
    <ContentCard
      href={slug}
      onClick={handleClick}
      imageSrc={hero_image}
      imageAlt={title}
      imageMaxWidth={400}
      imageAspectRatio={1.5}
      title={title}
      subtitle={subtitle}
      extras={sponsorLogoElement}
      className={styles.card}
      titleClassName={styles.title}
      subtitleClassName={styles.subtitle}
      titleMaxLines={2}
    />
  );
};

export default SponsoredListCard;
